import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { PurchaseOrderDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/purchase-order-dto';
import { PurchaseOrderLineItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/PurchaseOrderLineItems/purchase-order-line-item-dto';
import { TranslateService } from '@ngx-translate/core';
import { TaxRateV2Dto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/tax-rate-v-2-dto';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { Subscription } from 'rxjs';
import { InventoryService } from 'src/api/generated/services';
import { GetPurchaseOrder$Params } from 'src/api/generated/fn/inventory/get-purchase-order';
import { MenuCurrencyDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Menu/menu-currency-dto';
import { CurrencyService } from 'src/app/pos-panel/services/currency-helper/currency.service';

@Component({
  selector: 'app-received-purchase-order-details',
  templateUrl: './received-purchase-order-details.component.html',
  styleUrls: ['./received-purchase-order-details.component.scss']
})
export class ReceivedPurchaseOrderDetailsComponent implements OnInit, OnDestroy {

  venueId: string;
  inventoryId: string;
  purchaseOrderId: string;
  selectedItems: Array<PurchaseOrderLineItemDto> = new Array<PurchaseOrderLineItemDto>();
  taxRates: Array<TaxRateV2Dto> = new Array<TaxRateV2Dto>();
  selectedTaxRate: TaxRateV2Dto; 
  purchaseOrder: PurchaseOrderDto = {} as PurchaseOrderDto;
  venueIdUpdateSubscription: Subscription;
  currency: MenuCurrencyDto;
  timezoneOffset: any;

  constructor(public dialogService: DialogService, 
              private route: ActivatedRoute,
              private router: Router,
              public currencyService: CurrencyService,
              public translate: TranslateService,
              private currentVenueHelper: CurrentVenueHelperService,
              private inventoryService: InventoryService ) {
    
   
   }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.currentVenueHelper.getTimezone().subscribe(tzOffset => this.timezoneOffset = tzOffset)
      }
      if (params['inventory-id'] != null && params['purchase-order-id'] != null) {
        this.inventoryId = params['inventory-id'];
        this.purchaseOrderId = params['purchase-order-id'];
        
        const getParams: GetPurchaseOrder$Params = { inventoryId: this.inventoryId, purchaseOrderId: this.purchaseOrderId };
        this.inventoryService.getPurchaseOrder(getParams).subscribe( response => {
          this.purchaseOrder = response;
          this.selectedItems = this.purchaseOrder.lineItems ? this.purchaseOrder.lineItems.filter(order => order.quantityReceived != undefined && order.quantityReceived != 0) : [];
      })
    }
  });

  this.currencyService.currencyObservable().subscribe(currency => this.currency = currency);
  }

  navigateToMain() {
    this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 1 }});
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }
}
